import {Modal} from '@yandex-delivery/blocks'

import * as classes from './Body.classes'

type BodyProps = React.PropsWithChildren<{}>

export const Body = ({children}: BodyProps): React.ReactElement => (
  <Modal.Body className={classes.mobileDrawerBody} p={void 0}>
    {children}
  </Modal.Body>
)
